var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"title"},[_vm._v("Follow Up")]),_vm._v(" "),(!!_vm.followUp && _vm.followUp.name)?_c('div',{staticClass:"ui segment"},[_c('h5',[_vm._v(_vm._s(_vm.followUp.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.followUp.result))])]):_c('p',[_vm._v("No follow up")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f57ddee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/patients/patient_log_componenets/visit_history_components/VisitFollowUp.vue
// module id = null
// module chunks = 